import { useCallback } from "react";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import type { RequestOriginGroup } from "../../../utils/models";
import type { OriginFilterControl, RequestOriginFilterLayout } from "./requestOriginMeta";

/** The Origin filter's setter, tracked once per change with the layout it was made in. */
export const useOriginFilterChange = (control: OriginFilterControl, layout: RequestOriginFilterLayout): ((next: RequestOriginGroup[]) => void) => {
	const { track } = useAnalytics();
	const { chosenDepartment } = useHospitalData();
	const { onChange } = control;
	return useCallback(
		(next: RequestOriginGroup[]): void => {
			track("request_origin_filter_changed", { department_id: chosenDepartment.department_id, groups: next.join(","), layout });
			onChange(next);
		},
		[track, chosenDepartment.department_id, layout, onChange],
	);
};
